module.exports = {
    __esModule: true,
    default: function anonymous(props
) {
var out='<div data-playable-hook="player-container" tabindex="0" class="'+(props.styles.container)+'"></div>';return out;
} 
  };